"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UpcomingTasksCard = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _reactI18next = require("react-i18next");

var _core = require("@material-ui/core");

var _components = require("../../../components");

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {}
  };
});

var UpcomingTasksCard = function UpcomingTasksCard(_ref) {
  var tasks = _ref.tasks,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["tasks", "className"]);

  var classes = useStyles();

  var _useTranslation = (0, _reactI18next.useTranslation)('common'),
      t = _useTranslation.t;

  return /*#__PURE__*/_react.default.createElement(_components.StandardDisplayCard, _extends({
    title: t('dashboard.upcomingTasksTitle'),
    className: (0, _clsx.default)(classes.root, className)
  }, props), tasks !== null && tasks !== void 0 && tasks.length ? /*#__PURE__*/_react.default.createElement(_core.List, {
    dense: true
  }, tasks.map(function (task) {
    return /*#__PURE__*/_react.default.createElement(_core.ListItem, {
      button: true,
      key: task.id,
      component: _reactRouterDom.Link,
      to: "/projects/".concat(task.projectId, "/tasks")
    }, /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
      classes: {
        secondary: classes.description
      },
      primary: task.title,
      secondary: task.dueDate
    }));
  })) : /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6"
  }, t('dashboard.noUpcomingTasksMessage')));
};

exports.UpcomingTasksCard = UpcomingTasksCard;
UpcomingTasksCard.propTypes = {};
var _default = UpcomingTasksCard;
exports.default = _default;